import { Navigate, createFileRoute } from '@tanstack/react-router';

function ManageIndexRedirect() {
	return <Navigate to="/member-portal/overview" replace />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/')({
	component: ManageIndexRedirect,
});
